import { Update } from "@material-ui/icons";

const featuredMovie = [
  {
    backdrop:
      "https://www.themoviedb.org/t/p/original/2kXNQCe5E1kOxRTywrerai6i4mp.jpg",
    logo: "https://www.themoviedb.org/t/p/w500/nO5Uix3Qr4WjOyU1BMPv0okyNWm.png",
    desc: "Batman raises the stakes in his war on crime. With the help of Lt. Jim Gordon and District Attorney Harvey Dent, Batman sets out to dismantle the remaining criminal organizations that plague the streets. The partnership proves to be effective, but they soon find themselves prey to a reign of chaos unleashed by a rising criminal mastermind known to the terrified citizens of Gotham as the Joker.",
  },
  {
    backdrop:
      "https://www.themoviedb.org/t/p/w500_and_h282_face/nhbul32OIq2WKQT0OiN7rTZElpO.jpg",
    logo: "https://www.themoviedb.org/t/p/w500/n1WcT3DFvoiatzfKBLzMh9sUoBo.png",
    desc: "When Will decides to tell his daughter the story of how he met her mother, he discovers that a second look at the past might also give him a second chance at the future.",
  },
  {
    backdrop:
      "https://www.themoviedb.org/t/p/w500_and_h282_face/k1qmP045Mz0wu7BRY8v07rdEF65.jpg",
    logo: "https://www.themoviedb.org/t/p/w500/nVB8KGXV7wat8nuOWuuW4BUk5W4.png",
    desc: "Jack Torrance accepts a caretaker job at the Overlook Hotel, where he, along with his wife Wendy and their son Danny, must live isolated from the rest of the world for the winter. But they aren't prepared for the madness that lurks within.",
  },
  {
    backdrop:
      "https://www.themoviedb.org/t/p/original/bY2J2Jq8rSrKm5xCFtzYzqFh44o.jpg",
    logo: "https://www.themoviedb.org/t/p/w500/VQyMGRhehFzHLwpxzjMqeAEOm2.png",
    desc: "The everyday lives of office employees in the Scranton, Pennsylvania branch of the fictional Dunder Mifflin Paper Company.",
  },
  {
    backdrop:
      "https://www.themoviedb.org/t/p/w500_and_h282_face/ntxArhtReGCqQSWFXk0c0Yt8uDO.jpg",
    logo: "https://www.themoviedb.org/t/p/w500/izMoUwnmOcimN9xWO3JvBKtdYM2.png",
    desc: "World War II soldier-turned-U.S. Marshal Teddy Daniels investigates the disappearance of a patient from a hospital for the criminally insane, but his efforts are compromised by his troubling visions and also by a mysterious doctor.",
  },
  {
    backdrop:
      "https://www.themoviedb.org/t/p/w500_and_h282_face/kf456ZqeC45XTvo6W9pW5clYKfQ.jpg",
    logo: "https://www.themoviedb.org/t/p/w500/57YHzngGfuii29JCVIRwmS4Rxtr.png",
    desc: "Joe Gardner is a middle school teacher with a love for jazz music. After a successful gig at the Half Note Club, he suddenly gets into an accident that separates his soul from his body and is transported to the You Seminar, a center in which souls develop and gain passions before being transported to a newborn child. Joe must enlist help from the other souls-in-training, like 22, a soul who has spent eons in the You Seminar, in order to get back to Earth.",
  },
  {
    backdrop:
      "https://www.themoviedb.org/t/p/w500_and_h282_face/p8QlWpFsp0LYlfXH0jCX7ZjTsth.jpg",
    logo: "https://www.themoviedb.org/t/p/w500/6Du1dZ6LXxdrweJArWOMHglatmw.png",
    desc: "Fletcher Reede is a fast-talking attorney and habitual liar. When his son Max blows out the candles on his fifth birthday he has just one wish - that his dad will stop lying for 24 hours. When Max's wish comes true, Fletcher discovers that his mouth has suddenly become his biggest liability.",
  },
  {
    backdrop:
      "https://www.themoviedb.org/t/p/w500_and_h282_face/z6eMgnSt6VA0Gf9dirjpkBPu0uS.jpg",
    logo: "https://www.themoviedb.org/t/p/w500/n0wJ7MA4IcQN9606U22WlQjWb8J.png",
    desc: "Henry is a player skilled at seducing women. But when this veterinarian meets Lucy, a girl with a quirky problem when it comes to total recall, he realizes it's possible to fall in love all over again…and again, and again. That's because the delightful Lucy has no short-term memory, so Henry must woo her day after day until he finally sweeps her off her feet.",
  },
  {
    backdrop:
      "https://www.themoviedb.org/t/p/w500_and_h282_face/qz0C4Dd36TdiO5BVPMhemUNQsL2.jpg",
    logo: "https://www.themoviedb.org/t/p/w500/xi23eSwoibr5XeuZWBkTIBcA8O2.png",
    desc: "Carl Fredricksen spent his entire life dreaming of exploring the globe and experiencing life to its fullest. But at age 78, life seems to have passed him by, until a twist of fate (and a persistent 8-year old Wilderness Explorer named Russell) gives him a new lease on life.",
  },
  {
    backdrop:
      "https://www.themoviedb.org/t/p/w500_and_h282_face/jP2htGBHE7vKq4MLeC75UeC0sZH.jpg",
    logo: "https://www.themoviedb.org/t/p/w500/uUsNo7KjjwwAPBVbMeYbjutBsts.png",
    desc: "The true story of the investigation of the 'Zodiac Killer', a serial killer who terrified the San Francisco Bay Area, taunting police with his ciphers and letters. The case becomes an obsession for three men as their lives and careers are built and destroyed by the endless trail of clues.",
  },
];

export default featuredMovie;
